(ns dashboard.views.prototypes.question-clusters
  (:require ["react" :as react]
            [clojure.string :as str]
            [dashboard.common :as common]
            [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [dashboard.views.questionnaire.question-list.config :as question-list-config]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]))

(rf/reg-event-fx
 ::get-jobs
 (fn [_ _]
   {:http-xhrio {:method          :get
                 :uri             "/api/prototypes/cluster-jobs/"
                 :timeout         http-config/timeout
                 :format          http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :on-success      [::get-jobs-success]
                 :on-failure      [::ui/set-error {:message "Failed to get cluster jobs"}]}}))

(rf/reg-event-db
 ::get-jobs-success
 (fn [db [_ jobs]]
   (assoc db :cluster-job-id->cluster-job (into {} (map (juxt :id identity)) jobs))))

(rf/reg-sub
 ::cluster-jobs
 (fn [db _]
   (:cluster-job-id->cluster-job db)))

(rf/reg-event-fx
 ::get-clusters
 (fn [_ [_ job-id set-current-job-id]]
   {:http-xhrio {:method          :get
                 :uri             "/api/prototypes/cluster/"
                 :url-params      {:job-id job-id}
                 :timeout         http-config/timeout
                 :format          http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :on-success      [::get-clusters-success job-id set-current-job-id]
                 :on-failure      [::ui/set-error {:message "Failed to get cluster"}]}}))

(rf/reg-event-db
 ::get-clusters-success
 (fn [db [_ job-id set-current-job-id clusters]]
   (set-current-job-id job-id)
   (assoc-in db [:cluster-job-id->cluster-job job-id :members] clusters)))

(rf/reg-sub
 ::cluster-members
 (fn [db [_ job-id]]
   (get-in db [:cluster-job-id->cluster-job job-id :members])))

(defn View []
  (let [[current-job-id set-current-job-id] (react/useState nil)
        [hidden-clusters set-hidden-clusters] (react/useState #{})
        [ref set-ref] (react/useState nil)]
    (react/useEffect
     (fn []
       ;; TODO: Run on first mount only.
       ;; Seems that dispatching ::get-clusters cases another run of the hook,
       ;; possibly because ::cluster-members subscription causes a re-render, but somehow also triggers useEffect hook to run.
       ;; Would be good to figure out what is going on
       (when-not ref
         (rf/dispatch [::get-jobs]))
       (fn []))
     #js [])
    [:div
     {:ref set-ref}
     [:button
      {:on-click #(rf/dispatch [::get-jobs])}
      "Refresh jobs"]
     [:ul
      (for [[id {:keys [parameters clusters created]}] @(rf/subscribe [::cluster-jobs])]
        [:li
         {:key id}
         [:div
          "Job "
          [:b id]
          " run at "
          (common/format-date-time created)
          [:div.ml-2 "Parameters"]
          [:ul.ml-4
           (for [[k v] parameters]
             [:li.mr-2
              {:key k}
              (str (name k) ": " v)])]
          [:span.ml-2
           "Clusters: "
           (count clusters)]
          [:button.button.is-small.is-rounded.ml-2
           {:on-click #(rf/dispatch [::get-clusters id set-current-job-id])}
           "Show"]]])]
     (when current-job-id
       [:<>
        [:p.is-size-4.has-text-centered (str "Job " current-job-id)]
        [:table.table
         [:tbody
          (for [[group-idx [{:keys [cluster-id cluster-name]} members]] (sort-by #(-> % second second count)
                                                                                 #(compare %2 %1)
                                                                                 (map-indexed vector @(rf/subscribe [::cluster-members current-job-id])))]
            (let [hidden? (contains? hidden-clusters cluster-id)]
              [:<> {:key group-idx}
               [:tr {:key (str group-idx "-" cluster-id)}
                [:td
                 {:colSpan 2}
                 [:div.my-2.has-text-centered
                  (str cluster-name ", " (count members) " questions")
                  [:button.button.is-small.is-rounded.ml-2
                   {:on-click #(set-hidden-clusters (if hidden?
                                                      (disj hidden-clusters cluster-id)
                                                      (conj hidden-clusters cluster-id)))}
                   (if hidden?
                     [:i.icon.fas.fa-caret-down]
                     [:i.icon.fas.fa-caret-up])]]]]
               (when-not hidden?
                 (for [[member-idx {:keys [question-content questionnaire-name questionnaire-id]}] (map-indexed vector (sort-by (comp str/lower-case :question-content) members))]
                   [:tr {:key (str group-idx "-" member-idx)}
                    [:td
                     [:a
                      {:href (rfe/href question-list-config/view-id {:questionnaire-id questionnaire-id})}
                      questionnaire-name]]
                    [:td question-content]]))]))]]])]))
